import api from "../utils/api";

class RateHistoriesApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get("/rate-histories", { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getGroup = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get("/rate-histories/group", { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post("/rate-histories", data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };

  create_multiple = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post("/rate-histories/multiple", data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/rate-histories/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/rate-histories/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}

const rateHistoriesApi = new RateHistoriesApi();
export default rateHistoriesApi;
